import { EvidenceOfficerBase, EvidenceStatus, EvidenceType } from '@shared/utils/evidence-management';

export class EvidenceBaseResponse {
  constructor(
    public uid: string,
    public recordedOn: Date,
    public uploadedOn: Date,
    public title: string,
    public incidentNumber: string,
    public incidentCadNumber: string,
    public type: EvidenceType,
    public status: EvidenceStatus,
    public officer: EvidenceOfficerBase,
    public thumbnailFullPath: string | null,
    public isLocked: boolean,
    public removeScheduledOn?: Date
  ) {}
}

export class EvidenceOfficerBaseResponse {
  uid!: string;
  firstName!: string;
  lastName!: string;
}

export enum ListEvidenceDateRangeSearch {
  RecordedOn = 'RecordedOn',
  UploadedOn = 'CreatedOn',
  ActualFileDate = 'ActualFileDate',
}
